import "./ErpMicrovixFunctionalities.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToCgk from "./sections/WelcomeToCgk";
import KeyServiceFeatures from "./sections/KeyServiceFeatures";
import Footer from "@/reusable_sections/Footer";
export default function ErpMicrovixFunctionalitiesPage() {
  return <div>
      <Header />
      <WelcomeToCgk />
      <KeyServiceFeatures />
      <Footer />
    </div>;
}